import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1to55 extends React.PureComponent {
    static minValue = 1;
    static maxValue = 55;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [1, 55];

    static marks = {
        1: '1',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        55: '55',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={Leveling1to55.minValue}
                max={Leveling1to55.maxValue}
                marks={Leveling1to55.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1to55.js